import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

import {
  shouldShowCap
  , shouldShowCreditCharge
  , shouldShowEarlyTerminationDate
  , shouldShowEffectiveDate
  , shouldShowFloor
  , shouldShowHedgeProvider
  , shouldShowLowerStrike
  , shouldShowMarketCost
  , shouldShowTerm
  , shouldShowMaturityType
  , shouldShowNotional
  , shouldShowNotionalAtTermination
  , shouldShowPremium
  , shouldShowRate
  , shouldShowSpread
  , shouldShowStrike
  , shouldShowTerminationDate
  , shouldShowTerminationValue
  , shouldShowTradeDate
  , shouldShowUpperStrike
  , shouldShowHedgeTypeMonitored
  , shouldShowHedgeTypeActiveTerm
} from "./section-hedge-financials-rows-logic";

export const rows = {
  title: {
    label: "Financials",
    isTitle: true
  },
  hedgeStatus: {
    label: "Hedge Status",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "hedgeStatus",
        name: "hedgeStatusId",
        variant: "filled",
        options: [
          { name: "Active", id: "111f0b88-ff90-4e2e-a821-a7c18da94759" },
          { name: "Terminated", id: "222f0abc-ff90-4e2e-a821-a7c18da94759" },
          { name: "Monitored", id: "333f0789-ff90-4e2e-a821-a7c18da94759" }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  hedgeTypeMonitored: {
    isVisible: data => shouldShowHedgeTypeMonitored(data),
    label: "Hedge Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "hedgeType",
        name: "hedgeTypeId",
        variant: "filled",
        options: [
          { name: "Cap", id: "fc0fa822-733b-11e9-b768-0242ac120002" },
          { name: "Swap", id: "fe1fa999-733b-11e9-b768-0242ac120002" }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  hedgeTypeActiveTerm: {
    isVisible: data => shouldShowHedgeTypeActiveTerm(data),
    label: "Hedge Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "hedgeType",
        name: "hedgeTypeId",
        variant: "filled",
        options: [
          { name: "Cap", id: "fc0fa822-733b-11e9-b768-0242ac120002" },
          { name: "Swap", id: "fe1fa999-733b-11e9-b768-0242ac120002" },
          { name: "Corridor", id: "addfa123-733b-11e9-b768-0242ac120002" },
          { name: "Collar", id: "b73cb246-733b-11e9-b768-0242ac120002" },
          { name: "Floor", id: "a0449a2b-9d8b-11e9-8b5f-00ff12c3b408" },
          { name: "Any Lender Approved", id: "cdefa777-733b-11e9-b768-0242ac120002" }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  hedgeTerm: {
    isVisible: data => shouldShowTerm(data),
    label: "Term",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "term",
        variant: "filled",
        decimals: 3
      }
    ]
  },
  /*
   * marketRate: {
   *   isVisible: (data) => shouldShowMarketRate(data),
   *   label: 'Market Rate'
   *   , cells: [
   *     {
   *       type: FORM_BUILDER_FIELD_TYPE.PERCENT
   *       , name: "marketRate"
   *       , variant: "filled"
   *       , decimals: 2
   *     }
   *   ]
   * },
   */
  marketCost: {
    isVisible: data => shouldShowMarketCost(data),
    label: "Market Cost",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "marketCost",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  notional: {
    isVisible: data => shouldShowNotional(data),
    label: "Notional",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "notional",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  rate: {
    isVisible: data => shouldShowRate(data),
    label: "Rate",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "rate",
        variant: "filled",
        decimals: 3
      }
    ]
  },
  strike: {
    isVisible: data => shouldShowStrike(data),
    label: "Strike",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "strike",
        variant: "filled",
        decimals: 3
      }
    ]
  },
  upperStrike: {
    isVisible: data => shouldShowUpperStrike(data),
    label: "Upper Strike",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "upperStrike",
        variant: "filled",
        decimals: 3
      }
    ]
  },
  lowerStrike: {
    isVisible: data => shouldShowLowerStrike(data),
    label: "Lower Strike",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "lowerStrike",
        variant: "filled",
        decimals: 3
      }
    ]
  },
  cap: {
    isVisible: data => shouldShowCap(data),
    label: "Cap",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "cap",
        variant: "filled",
        decimals: 3
      }
    ]
  },
  floor: {
    isVisible: data => shouldShowFloor(data),
    label: "Floor",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "floor",
        variant: "filled",
        decimals: 3
      }
    ]
  },
  terminationValue: {
    isVisible: data => shouldShowTerminationValue(data),
    label: "Termination Value/Cost",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "terminationValue",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  notionalAtTermination: {
    isVisible: data => shouldShowNotionalAtTermination(data),
    label: "Notional at Termination",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "notionalAtTermination",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  index: {
    label: "Index",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "index",
        name: "indexId",
        variant: "filled",
        parentId: "floatingIndexes",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  tradeDate: {
    isVisible: data => shouldShowTradeDate(data),
    label: "Trade Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "tradeDate",
        variant: "filled",
        decimals: 2,
        monthStyle: { minWidth: "176px" },
        dayStyle: { width: "80px", marginLeft: "16px" },
        yearStyle: { width: "80px", marginLeft: "16px" }
      }
    ]
  },
  effectiveDate: {
    isVisible: data => shouldShowEffectiveDate(data),
    label: "Effective Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "effectiveDate",
        variant: "filled",
        decimals: 2,
        monthStyle: { minWidth: "176px" },
        dayStyle: { width: "80px", marginLeft: "16px" },
        yearStyle: { width: "80px", marginLeft: "16px" }
      }
    ]
  },
  terminationDate: {
    isVisible: data => shouldShowTerminationDate(data),
    label: "Termination Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "terminationDate",
        variant: "filled",
        decimals: 2,
        monthStyle: { minWidth: "176px" },
        dayStyle: { width: "80px", marginLeft: "16px" },
        yearStyle: { width: "80px", marginLeft: "16px" }
      }
    ]
  },
  earlyTerminationDate: {
    isVisible: data => shouldShowEarlyTerminationDate(data),
    label: "Early Termination Date",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DATE,
        name: "earlyTerminationDate",
        variant: "filled",
        decimals: 2,
        monthStyle: { minWidth: "176px" },
        dayStyle: { width: "80px", marginLeft: "16px" },
        yearStyle: { width: "80px", marginLeft: "16px" }
      }
    ]
  },
  maturityType: {
    isVisible: data => shouldShowMaturityType(data),
    label: "Maturity Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "maturityType",
        name: "maturityTypeId",
        variant: "filled",
        /*
         * parentId: MATURITY_TYPES,
         * options: [],
         */
        options: [
          { id: "0b11849b-9bed-11e9-8b5f-00ff12c3b408", name: "Rolling Maturity" },
          { id: "1253d73b-9bed-11e9-8b5f-00ff12c3b408", name: "Constant Maturity" }
        ],
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }

      }
    ]
  },
  premium: {
    isVisible: data => shouldShowPremium(data),
    label: "Premium",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.DOLLAR,
        name: "premium",
        variant: "filled",
        decimals: 0
      }
    ]
  },

  hedgeProvider: {
    isVisible: data => shouldShowHedgeProvider(data),
    label: "Hedge Provider",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "hedgeProvider",
        name: "hedgeProviderId",
        variant: "filled",
        parentId: "companiesByTypeId",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }
      }
    ]
  },

  spread: {
    isVisible: data => shouldShowSpread(data),
    label: "Spread",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.PERCENT,
        name: "spread",
        variant: "filled",
        decimals: 3
      }
    ]
  },
  creditCharge: {
    isVisible: data => shouldShowCreditCharge(data),
    label: "Credit Charge (bps)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "creditCharge",
        variant: "filled",
        decimals: 3
      }
    ]
  }
};

